/** Khoảng trống tối thiểu dưới khối thấp nhất (px) — tránh mép kéo “chạm” sát element */
export const CANVAS_SECTION_MIN_TAIL_PX = 6;

/**
 * Chiều cao tối thiểu (px) để chứa hết khối theo layout hiện tại (đáy thấp nhất + margin).
 * Dùng khi kéo cao trang lên / nhập số — không cho thu nhỏ quá để mép không “đè” lên phần tử.
 */
export function computeCanvasSectionMinHeightPx(
  blocks: Array<{ y?: number; h?: number }>,
  sectionHeightPx: number,
): number {
  const H = Math.max(1, Math.round(sectionHeightPx || 480));
  let maxBottomPx = 0;
  for (const blk of blocks) {
    const y = blk.y ?? 0;
    const h = blk.h ?? 10;
    const bottomPx = ((y + h) / 100) * H;
    maxBottomPx = Math.max(maxBottomPx, bottomPx);
  }
  const withTail = Math.ceil(maxBottomPx) + CANVAS_SECTION_MIN_TAIL_PX;
  return Math.max(200, Math.min(20000, withTail));
}

/**
 * Khi chiều cao section (px) thay đổi, giữ nguyên kích thước & vị trí pixel của khối
 * (top/height theo %) — chỉ kéo dài phần trống, không “dãn” nút/chữ.
 */
export function rescaleBlocksYhPreservingPixelSize(
  blocks: Array<{ y?: number; h?: number }>,
  oldSectionHeightPx: number,
  newSectionHeightPx: number,
): void {
  const oldPx = Math.max(1, Math.round(oldSectionHeightPx || 480));
  const newPx = Math.max(1, Math.round(newSectionHeightPx || 480));
  if (oldPx === newPx) return;

  for (const blk of blocks) {
    const py = blk.y ?? 0;
    const ph = blk.h ?? 10;
    const topPx = (py / 100) * oldPx;
    const hPx = (ph / 100) * oldPx;
    let ny = (topPx / newPx) * 100;
    let nh = (hPx / newPx) * 100;
    ny = Math.round(ny * 10) / 10;
    nh = Math.round(nh * 10) / 10;
    nh = Math.max(0.5, Math.min(100, nh));
    ny = Math.max(0, Math.min(100 - nh, ny));
    blk.y = ny;
    blk.h = nh;
  }
}
